import { verboseApiErrorsInTest } from "../../config/featureConfig";

function truncate(value, maxLen = 400) {
  const text = String(value ?? "");
  if (text.length <= maxLen) {
    return text;
  }
  return `${text.slice(0, maxLen)}…`;
}

function extractBackendMessage(data) {
  if (data == null) {
    return null;
  }
  if (typeof data === "string") {
    return data.trim() || null;
  }
  if (typeof data === "object") {
    const record = data;
    if (typeof record.message === "string" && record.message.trim()) {
      return record.message.trim();
    }
    if (typeof record.error === "string" && record.error.trim()) {
      return record.error.trim();
    }
  }
  return null;
}

export function buildUserFacingHttpMessage({ status, message, data, url, method } = {}) {
  const backend = extractBackendMessage(data);
  const generic500 = "Si e verificato un problema sul server. Riprova piu tardi.";

  if (status === 500 || status === 502 || status === 503 || status === 504) {
    if (!verboseApiErrorsInTest) {
      return generic500;
    }
    const parts = [`Errore HTTP ${status ?? "?"}`];
    if (method && url) {
      parts.push(`${String(method).toUpperCase()} ${url}`);
    }
    if (backend) {
      parts.push(backend);
    } else if (message) {
      parts.push(truncate(message));
    }
    return parts.join(" — ");
  }

  if (backend) {
    return backend;
  }
  if (message) {
    return String(message);
  }
  return "Si e verificato un problema imprevisto.";
}

export function buildDeveloperDetail({ status, data, url, method, message } = {}) {
  if (!verboseApiErrorsInTest) {
    return null;
  }
  const lines = [];
  if (status != null) {
    lines.push(`status: ${status}`);
  }
  if (method && url) {
    lines.push(`request: ${String(method).toUpperCase()} ${url}`);
  }
  if (message) {
    lines.push(`client: ${truncate(message, 200)}`);
  }
  if (data != null) {
    try {
      lines.push(`body: ${truncate(typeof data === "string" ? data : JSON.stringify(data, null, 2), 800)}`);
    } catch {
      lines.push(`body: ${truncate(String(data), 800)}`);
    }
  }
  return lines.length > 0 ? lines.join("\n") : null;
}
